import { render } from "./Locate.vue?vue&type=template&id=3d65df6a&scoped=true"
import script from "./Locate.vue?vue&type=script&lang=js"
export * from "./Locate.vue?vue&type=script&lang=js"

import "./Locate.vue?vue&type=style&index=0&id=3d65df6a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d65df6a"]])

export default __exports__